<template>
<v-flex>
    <h1 style="color: #969462 !important;">Balancetes Analíticos</h1>
    <v-dialog v-model="loader" persistent width="350">
        <v-card color="#969462" dark>
            <v-card-text>
                Esta operação pode demorar alguns minutos.<br>
                Por favor aguarde...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-flex xs12 sm12 md12>
        <v-layout row wrap>
            <v-flex v-if="getSession.user.super == 1" xs3 sm3 md3>
                <label class="label-modal">Cliente</label>
                <v-autocomplete color="#969462" :items="getClientes" @change="setAnos()" v-model="cliente"  item-text="nome" item-value="codigo"></v-autocomplete>
            </v-flex>
            <v-flex xs3 sm3 md3 v-bind:class="getSession.user.super == 1 ? 'pl-5' : ''">
                <label class="label-modal">Ano</label>
                <v-autocomplete color="#969462" :items="anos" v-model="ano"></v-autocomplete>
            </v-flex>
            <v-flex v-bind:class="getSession.user.super == 0 ? 'xs3 sm3 md3 pl-5' : 'xs2 sm2 md2 pl-5'">
                <label class="label-modal">Mês</label>
                <v-autocomplete color="#969462" :items="meses" v-model="mes" item-text="nome" item-value="mes"></v-autocomplete>
            </v-flex>
            <!-- <v-flex v-bind:class="getSession.user.super == 0 ? 'xs3 sm3 md3 pl-5' : 'xs2 sm2 md2 pl-5'">
                <label class="label-modal">Mês fim</label>
                <v-autocomplete color="#969462" :items="meses" v-model="mesFim" item-text="nome" item-value="mes"></v-autocomplete>
            </v-flex> -->
            <v-flex v-bind:class="getSession.user.super == 0 ? 'xs3 sm3 md3' : 'xs2 sm2 md2'" style="position: relative;">
                <v-btn @click="searchData" dark color="#969462" class="btnSearch">Pesquisar</v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
    <div class="elevation-3">
        <div class="tableHeader">
            <v-btn dark @click="generatePdf()" color="#969462">Exportar</v-btn>
            <v-text-field color="#969462" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </div>
        <v-data-table :headers="headers" :items="DATA" :search="search" item-key="id" :disable-initial-sort="true" color="#969462" :rows-per-page-items='[50,150,300,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
            <template slot="items" slot-scope="props">
                <td class="textLeft">{{props.item.codigoconta || '-'}}</td>
                <td class="textLeft">{{props.item.designacao || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.valordebitos) || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.valorcreditos) || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.valordebitosacumulados) || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.valorcreditosacumulados) || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.saldosdeb) || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.saldoscred) || '-'}}</td>
            </template>

            <template v-if="DATA.length > 0" slot="footer">
                <td class="textLeft" colspan="2"><strong>Total</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(TOTAIS['valordebitos'])}}</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(TOTAIS['valorcreditos'])}}</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(TOTAIS['valordebitosacumulados'])}}</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(TOTAIS['valorcreditosacumulados'])}}</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(TOTAIS['saldosdeb'])}}</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(TOTAIS['saldoscred'])}}</strong></td>
            </template>

            <template class="alertTable" slot="no-data">
                <v-alert :value="true" icon="warning">
                    De momento não há nada a apresentar! :(
                </v-alert>
            </template>
        </v-data-table>

    </div>
</v-flex>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";

import axios from 'axios';
import qs from 'qs';
import convert from "xml-js";

const cName = {
    upper: "Balancete analítico",
    lower: "o balancete analítico!"
};

export default {
    data: () => ({
        table: 'utilizadores',
        name: 'balancete',
        search: "",
        searchP: '',
        loader: false,
        headers: [{
                text: "Código",
                align: "left",
                sortable: true,
                value: "codigoconta"
            },
            {
                text: "Designação",
                align: "left",
                sortable: true,
                value: "designacao"
            },
            {
                text: "Débitos Mensais €",
                align: "right",
                sortable: true,
                value: "valordebitos"
            },
            {
                text: "Créditos Mensais €",
                align: "right",
                sortable: true,
                value: "valorcreditos"
            },
            {
                text: "Débitos Acumulados €",
                align: "right",
                sortable: true,
                value: "valordebitosacumulados"
            },
            {
                text: "Créditos Acumulados €",
                align: "right",
                sortable: true,
                value: "valorcreditosacumulados"
            },
            {
                text: "Saldos Devedores €",
                align: "right",
                sortable: true,
                value: "saldosdeb",
            },
            {
                text: "Saldos Credores €",
                align: "right",
                sortable: true,
                value: "saldoscred",
            }
        ],
        anos: [],
        TOTAIS: {},
        meses: [{
                mes: 1,
                nome: 'Janeiro'
            },
            {
                mes: 2,
                nome: 'Fevereiro'
            },
            {
                mes: 3,
                nome: 'Março'
            },
            {
                mes: 4,
                nome: 'Abril'
            },
            {
                mes: 5,
                nome: ' Maio'
            },
            {
                mes: 6,
                nome: 'Junho'
            },
            {
                mes: 7,
                nome: 'Julho'
            },
            {
                mes: 8,
                nome: 'Agosto'
            },
            {
                mes: 9,
                nome: 'Setembro'
            },
            {
                mes: 10,
                nome: 'Outubro'
            },
            {
                mes: 11,
                nome: 'Novembro'
            },
            {
                mes: 12,
                nome: 'Dezembro'
            }
        ],
        DATA: [],
        cliente: '',
        ano: '',
        mes: '',
        mesFim: '',
        messages: {
            add: {
                success: cName.upper + " criado com sucesso!",
                error: "Ocorreu um erro ao criar " + cName.lower
            },
            update: {
                success: cName.upper + " alterado com sucesso!",
                error: "Ocorreu um erro ao alterar " + cName.lower
            },
            delete: {
                success: cName.upper + " eliminado com sucesso!",
                error: "Ocorreu um erro ao apagar " + cName.lower
            },
            default: {
                sucesso: "Sucesso",
                error: "Ocorreu um erro!"
            }
        }
    }),

    computed: {
        ...mapGetters({
            getSession: 'session/getState',
            getClientes: 'utilizadores/getClientes',
            getClienteByCodigo: 'utilizadores/getClienteByCodigo',
            getLinks: 'session/getLinks'
        }),
    },

    watch: {},

    created() {
        //this.ano = Number(this.$moment().format('YYYY'));
        if (this.getSession.user.super == 0) this.cliente = this.getSession.user.codigo;

        setTimeout(() => {
            try {
                this.setAnos();
            } catch (error) {
                setTimeout(() => {
                    try {
                        this.setAnos();
                    } catch (error) {
                    }
                }, 500);
            }
        }, 500);
    },
    mounted() {

    },
    methods: {
        numberWithSpaces(x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },

        setAnos() {
            if (this.getSession.user.super == 0) this.anos = this.getSession.user.anos;
            else this.anos = this.getClienteByCodigo(this.cliente).anos;
        },

        toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },

        generatePdf() {
            if(this.DATA.length == 0) return;
            
            this.loader = true;
            var cliente = this.getClienteByCodigo(this.cliente);
            var nome = this.$moment().unix();
            this.$store.dispatch('contas/generatePdfAnalitico', {
                data: this.DATA,
                totais: this.TOTAIS,
                mes: this.meses.find((el)=>{ return el.mes == this.mes }).nome,
                ano: this.ano,
                cliente: cliente.codigo+' - '+cliente.nome,
                nif: cliente.nif,
                nome: nome
            }).then((res)=>{
                if(res) window.open(this.$pdfURL+nome+'.pdf', '_blank')
                else this.toast('error', 'Ocorreu um erro ao exportar.');

                this.loader = false;
            })
        },

        getTotalByProperty(prop) {
            if(this.DATA.length==0) return 0
            else return this.DATA.map((el)=>{ return el[prop] }).reduce((a,b)=>(parseFloat(String(a).replace(',','.'))+parseFloat(String(b).replace(',','.'))).toFixed(2)) + ' €'
        },

        searchData() {
            if (!this.ano) {
                this.toast('error', 'Ano não definido.');
                return;
            } else if (!this.mes) {
                this.toast('error', 'Mês não definido.');
                return;
            }

            var url = this.getLinks.balanceteAURL;
            this.loader = true;
            const options = {
                method: 'POST',
                crossDomain: true,
                async: true,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify({
                    invocationPassword: this.$servicePWD,
                    cliente: this.cliente,
                    ano: this.ano,
                    mes: this.mes,
                    mesfim: ''
                }),
                url,
            };

            axios(options).then((res) => {
                var result = JSON.parse(JSON.parse(convert.xml2json(res.data, {
                    compact: true,
                    spaces: 4
                })).string._text);

                this.DATA = Array.isArray(result) ? result : [];

                if (this.DATA.length == 0) this.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
                else {
                    this.TOTAIS = {
                        valordebitos: this.getTotalByProperty('valordebitos'),
                        valorcreditos: this.getTotalByProperty('valorcreditos'),
                        valordebitosacumulados: this.getTotalByProperty('valordebitosacumulados'),
                        valorcreditosacumulados: this.getTotalByProperty('valorcreditosacumulados'),
                        saldosdeb: this.getTotalByProperty('saldosdeb'),
                        saldoscred: this.getTotalByProperty('saldoscred')
                    }
                }

                this.loader = false;
            }).catch((err) => {
                this.DATA = [];
                this.loader = false;
                this.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
            })
        },
    }
}
</script>

<style scoped>
.btnSearch {
    position: absolute;
    bottom: 20%;
    width: 87%;
    margin-left: 12.5%;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/Table_Balancete_Analitico.vue